import React, { useState } from 'react'
import { Modal, Paper, Typography, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { toastAlert } from '../../../utils/AlertContext';
import { getDeletePayURL } from "../../../utils/ConstantsURL";

export const DeletePay = ({ token, open, close, IdPay, refresh }) => {
  const [loading, setLoading] = useState(false);
    
  const handleDeletePay = async () => {
    setLoading(true);
    try {
      const response = await fetch(getDeletePayURL(IdPay), {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
  
      if (!response.ok) {
        toastAlert('Error al eliminar el pay', 'error');
        setLoading(false);
        return;
      }

      toastAlert('Pay eliminado correctamente', 'success');
      setLoading(false);
      close();
      refresh();
    } catch (error) {
      toastAlert('Error al eliminar el pay: ' + error, 'error');
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={close}>
      <Paper
          elevation={2}
          style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          padding: '20px',
          display: 'flex',
          flexDirection: 'column',
          outline: 'none',
          }}
      >
        <Typography variant="h6">
          ¿Estás seguro de que deseas eliminar este pay?
        </Typography>
        <Typography variant="subtitle1" style={{ margin: '10px 0' }}>
          Esta acción no se puede deshacer.
        </Typography>
        <div style={{ display: 'flex', justifyContent: 'end' }}>
          <Button variant="contained" onClick={close} color="error">
            Cancelar
          </Button>
          <LoadingButton
            variant="contained"
            color="primary"
            style={{ marginLeft: '20px' }}
            onClick={handleDeletePay}
            loading={loading}
          >
            Confirmar
          </LoadingButton>
        </div>
      </Paper>
    </Modal>
  );
};
